import Vue from 'vue'
import Vuex from 'vuex'
import metaremote from '@/metaremote.js'
import jwt from 'jsonwebtoken'
import apiclient from '@/apiclient.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    logoimage:'',
    active_tab:'',
    tabs:[],
    mandati:[],

    login: false,
    auth: {},
    connection: {
      myid: '',
      myid_token: '',
      mytokenizedid: '',
      mytoken: '',
      userdata: {},
      zona: '',
    },
    // google payload
    identity: {},
    // google decoded user
    user: {
      id: '',
      id_token: '',
      name: '',
      imageUrl: '',
      email: ''
    },
    multizona: false,
    zone: [],
    position: {
      gps: false,
      lat: undefined,
      lng: undefined
    },
    devices: [],
    deviceback:'',
    map: {},
    campagne: [ 
      "2026 RE", "2026 NA", "2026 VF", "2026 SC",            "2026 PW", 
      "2025 RE", "2025 NA", "2025 VF", "2025 SC", "2025 VS", "2025 PW", 
                                                                        "2024 KK" 
    ],
    objects: [],
    filtrocategoria: [true,true,true,true,true ],
    filtrotipo:0,
    filtrotipi: [{checked:true},{checked:true},{checked:false}]
  },
  getters: {
    connection: function(state) { return state.connection },
    logged: function(state) { return state.login },
    auth: function(state) { return state.auth },
    identity: function(state) { return state.identity },
    map: function(state) { return state.map },
    position: function(state) { return state.position },
    zona: function(state) { return state.connection.zona },
    zone: function(state) { return state.zone },
    permissions: function(state) { 
      if (state.connection) {
        if (state.connection.userdata) {
          if (state.connection.userdata.SalesPaddy_Permissions__c) {
            return state.connection.userdata.SalesPaddy_Permissions__c.split(";");
          }
        }
      }
    },
    isAdmin: function(state, getters) { 
      var p=getters.permissions;
      if (p)
        return p.indexOf("Admin")>=0;
      return false;
    },
    isAreaManager: function(state, getters) { 
      var p=getters.permissions;
      if (p)
        return p.indexOf("Area Manager")>=0;
      return false;
    },
    enablemap: function(state, getters) { 
      var p=getters.permissions;
      if (!p) return false;
      if (p.indexOf("Dealer Admin")>=0) return true;
      if (p.indexOf("Dealer Sales")>=0) return true;
      return false;
    },
  },
  mutations: {
    SET_FILTROTIPO: function(state, payload)        { state.filtrotipo = payload; },
    SET_FILTROTIPI: function(state, payload)        { state.filtrotipi = payload; },
    SET_FILTROCATEGORIE: function(state, payload)   { state.filtrocategoria[payload] = !state.filtrocategoria[payload]; },

    SET_LOGOIMAGE: function(state, payload)        { state.logoimage = payload; },
    SET_ZONE: function(state, payload)        { state.zone = payload; if (payload.length>1) state.multizona=true },
    SET_ZONA: function(state, payload)        { state.connection.zona = payload; },
    SET_DEALER: function(state, payload)        { state.connection.userdata.AccountId = payload; },
    SET_CAMPAGNE: function(state, payload) { state.campagne=payload },
    SET_TABS: function(state, payload) { state.tabs=payload },
    SET_ACTIVE_TAB: function(state, payload) { state.active_tab=payload },
    SET_MANDATI: function(state, payload) { state.mandati=payload },
    SET_AUTH: function(state, payload)              { state.auth = payload; },

    SET_CONNECTION: function(state, payload)        {
      state.connection = payload;
      if (payload.userdata && payload.userdata.agentcodes && payload.userdata.agentcodes.length>0) {
        state.connection.zona = payload.userdata.agentcodes[0];
        if (payload.userdata.agentcodes.length>1) state.multizona=true;
      }
    },
    SET_CONNECTION_TOKEN: function(state, payload)  {
      state.connection.mytoken = payload.mytoken;
      state.connection.mytokenizedid = payload.mytokenizedid;
      state.connection.userdata = payload.userdata;

      if (payload.userdata && payload.userdata.agentcodes && payload.userdata.agentcodes.length>0) {
        state.connection.zona = payload.userdata.agentcodes[0];
        if (payload.userdata.agentcodes.length>1) state.multizona=true;
      }
    },
    SET_USERDATA: function(state, payload)  {
      state.connection.userdata = payload.userdata;
    },
    SET_LOGIN: function(state, payload)             { state.login = payload; },
    SET_GOOGLE_IDENTITY: function(state, payload) {
      state.identity = payload;
      var profile = payload.getBasicProfile();
      state.user.id_token=payload.getAuthResponse().id_token;
      state.user.id = profile.getId();
      state.user.name = profile.getName();
      state.user.imageUrl = profile.getImageUrl();
      state.user.email = profile.getEmail();
      //this.user.givename=this.profile.getGivenName();
      //this.user.familyname=this.profile.getFamilyName();
    },
    SET_MS_IDENTITY: function(state, payload) {
      state.identity = payload;

      state.user.id_token=payload.id_token;
      state.user.id = payload.oid;
      state.user.name = payload.given_name+' '+payload.family_name;
      state.user.givename = payload.given_name;
      state.user.familyname = payload.family_name;
      if (payload.emails) state.user.email = payload.emails[0];
//      state.user.imageUrl = payload.getImageUrl();
      //this.user.givename=this.profile.getGivenName();
      //this.user.familyname=this.profile.getFamilyName();
    },
    SET_MAP: function(state, payload)               { state.map = payload; },
    SET_POSITION: function(state, payload) {
      state.position.gps = true;
      state.position.lat = payload.lat;
      state.position.lng = payload.lng;
    },
    SET_DEVICES: function(state, payload) { state.devices=payload; },
    SET_DEVICE_BACK: function(state, payload) { state.deviceback=payload; },
    SET_OBJ: function(state,payload ) { state.objects[payload.name]=payload.value }
  },
  modules: {
  },
  actions: {
    getLocalUser: function(context) {
      return new Promise(function(resolve, reject) {
        var userData=localStorage.getItem('fcpcustomerpaddy');
        apiclient.getKey();
        console.log(userData);
        console.log(apiclient.secret);
        if (userData) {
          jwt.verify(userData, apiclient.secret, function(err, data) {
            if (err) {
              console.log('bad localStorage: jwt broken');
              reject();
            } else {
              context.commit('SET_USERDATA', data);
              resolve(data);
            }
          });
        } else {
          reject()
        }
    })
  },
    setLocalUser: function(context, payload) {
      var jwtpayload = jwt.sign( payload, apiclient.secret);
      localStorage.setItem('fcpcustomerpaddy', jwtpayload); 
    },
    getDevices: function(context) {
      return new Promise(function(resolve, reject) {
        if (!navigator.mediaDevices) reject();
        navigator.mediaDevices.enumerateDevices().then(function(devices) {
          context.commit('SET_DEVICES', devices);
          var deviceId;
          devices.forEach(function(d) {
            if (d.kind == "videoinput" && d.label.toLowerCase().includes("back")) {
              context.commit('SET_DEVICE_BACK', deviceId);
            }
          });
          resolve();
        }).catch(function(err) {
          reject(err);
        })
      });
    },
    getPosition: function(context) {
      return new Promise(function(resolve, reject) {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function(position) {
            var pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };

            console.log('position ok');
            console.log(pos);
            context.commit('SET_POSITION', pos);
            resolve();
          }, function() {
            reject();
          });
        } else {
          reject();
        }
      });
    },
    showMapMsg: function(context, payload) {
      var pos = context.getters.position;
      var map = context.getters.map;
      console.log(pos);
      // eslint-disable-next-line no-undef
      this.infoWindow = new google.maps.InfoWindow;
      this.infoWindow.setPosition(payload.pos);
      this.infoWindow.setContent(payload.msg);
      this.infoWindow.open(map);
    },
    moveToMyPos: function(context) {
      var pos = context.getters.position;
      var map = context.getters.map;
      console.log(pos);
      if (map && map.setCenter)
        map.setCenter(pos);
    },
    loadMandati: function(context) {
      console.log('loadMandati');
      context.commit('SET_MANDATI',[]);
    },
    signOut: function(context) {
      localStorage.removeItem('fcpcustomerpaddy');
      context.commit('SET_LOGIN', false);
//      window.location.href=daviam.getLogoff(daviam.cfg, context.state.identity.id_token, window.location.hostname);
    },
    initmeta: function(context) {
      console.log('initmeta');
      context.dispatch('gettabs').then(function() {
//        context.dispatch('getcampagne');
      })
    },
    gettabs: function(context) {
      return new Promise(function(resolve, reject) {
        console.log('gettabs');
        //metaremote.setSecret(context.getters.connection.secret);
        metaremote.get(context.getters.connection, 'tabs').then(function(res) {
          console.log('metaremote tabs get');
          console.log(res);
          if (res) {
            context.commit('SET_TABS', res );
            context.commit('SET_ACTIVE_TAB', res[0].name);    
          } else {
            console.log('meta tabs problemi')
          }
          resolve();
        }).catch(function(err) {
          reject(err);
        });
      });
    },
    getcampagne: function(context) {
      return new Promise(function(resolve, reject) {
        console.log('getcampagne');
        //metaremote.setSecret(context.getters.connection.secret);
        metaremote.get(context.getters.connection, 'campagne').then(function(res) {
          console.log('metaremote campagne get');
          console.log(res);
          if (res) {
            context.commit('SET_CAMPAGNE', res );
          } else {
            console.log('meta campagne problemi')
          }
          resolve();
        }).catch(function(err) {
          reject(err);
        });
      });
    }  

  }
})
